module.exports = __webpack_public_path__ + "static/media/APWastelandEXTBlackHoleA0011_bg_clean_v001.33a8cd5a.webp";